<script setup lang="ts">
import { pb } from "@/pocketbase";
import Title from "@/components/Title.vue";
import LinkBox from "@/components/LinkBox.vue";
import Heading from "@/components/Heading.vue";
import Divider from "@/components/Divider.vue";
import Content from "@/components/Content.vue";
import { Product } from "@/model";

const products: Product[] = await pb.collection('products').getFullList<Product>(null, {
  expand: 'businessUnit',
  sort: 'businessUnit.name,name',
  '$autoCancel': false,
});

const productsByBusinessUnit: {
  [index: string]: {
    id: string,
    name: string,
    logo: string,
    products: {
      id: string;
      name: string,
      description: string,
    }[],
  }
} = {};

for (const product of products) {
  if (!productsByBusinessUnit[product.businessUnit]) {
    productsByBusinessUnit[product.businessUnit] = {
      id: product.businessUnit,
      name: product.expand!.businessUnit!.name,
      logo: product.expand!.businessUnit!.logo,
      products: [],
    };
  }
  productsByBusinessUnit[product.businessUnit].products.push({
    id: product.id,
    name: product.name,
    description: product.description,
  });
}
</script>

<template>
  <Title subtitle="and their products">Business Units</Title>
  <Divider/>
  <Content>
    <template v-for="businessUnit in productsByBusinessUnit">
      <Heading>{{ businessUnit.name }}</Heading>

      <div class="flex w-full gap-2 lg:gap-5">
        <div class="flex items-center w-48 rounded-lg border px-5 py-4 border-gray-200 dark:border-gray-700">
          <img class="w-full object-contain" :src="pb.files.getUrl({
            id:businessUnit.id,
            collectionName: 'business_units',
          }, businessUnit.logo)" :alt="`Logo of ${businessUnit.name}`"/>
        </div>
        <div class="grid lg:grid-cols-2 gap-2 lg:gap-5 w-full">
          <LinkBox v-for="product in businessUnit.products"
                   route="product" :route-params="{ id: product.id }"
                   :title="product.name" :description="product.description || 'No description available yet'"/>
        </div>
      </div>
    </template>
  </Content>
</template>

